import Alert from '@mui/material/Alert';

import Grid from '@mui/material/Grid';

import { ReportDateFilterSelect } from '@/components/reports/forms/dateFilterSelect';
import { ReportGenericFilterSelect } from '@/components/reports/forms/genericFilterSelect';
import { ReportGenericSearchTermFilter } from '@/components/reports/forms/genericSearchTermFilter';

import { FilterInputConfigError } from '../../forms/filterInputConfigError';
import { FilterValues, ReportFilter } from '../../types/filters';

interface FilterBarProps {
  filterValues: FilterValues;
  filters: ReportFilter[];
  handleFilterChange: (filter: string) => (value: string | null) => void;
}

export const FilterBar = ({ filterValues, filters, handleFilterChange }: FilterBarProps) => {
  if (!Array.isArray(filters)) {
    return <Alert severity="error">Filters are not in the right format</Alert>;
  }

  return (
    <Grid container={true} justifyContent="flex-end" spacing={1}>
      {filters?.map((current) => (
        <Grid key={current.filterLabel}>
          {(() => {
            const { filterExpression, filterLabel, options, query, type } = current;
            const props = {
              ...current,
              onChange: handleFilterChange(filterLabel),
              selectedFilter: filterValues[filterLabel as keyof FilterValues],
            };

            if (!filterLabel) {
              return (
                <FilterInputConfigError
                  filterLabel={filterLabel}
                  message={`Config needs a filterLabel`}
                  type={type}
                />
              );
            }

            if (!filterExpression) {
              return (
                <FilterInputConfigError
                  filterLabel={filterLabel}
                  message={`Config needs a filterExpression`}
                  type={type}
                />
              );
            }

            if (!filterExpression.includes('?')) {
              return (
                <FilterInputConfigError
                  filterLabel={filterLabel}
                  message={`filterExpression should be of the form field = '?'`}
                  type={type}
                />
              );
            }

            try {
              switch (type) {
                case 'date': {
                  return <ReportDateFilterSelect {...props} />;
                }
                case 'search': {
                  return <ReportGenericSearchTermFilter {...props} />;
                }
                default: {
                  if (!query && !options) {
                    return (
                      <FilterInputConfigError
                        filterLabel={filterLabel}
                        message={'Config needs a query or options'}
                        type={type}
                      />
                    );
                  }

                  return <ReportGenericFilterSelect {...props} />;
                }
              }
            } catch (error) {
              return (
                <FilterInputConfigError filterLabel={filterLabel} message={error} type={type} />
              );
            }
          })()}
        </Grid>
      ))}
    </Grid>
  );
};
